import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@24.3.0_db0@0.3.2_esl_280ec7ac1d31aea7e256dde11e08acab/node_modules/nuxt/dist/pages/runtime/validate.js";
import trailing_45slash_45global from "/opt/buildhome/repo/middleware/trailing-slash.global.ts";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@24.3.0_db0@0.3.2_esl_280ec7ac1d31aea7e256dde11e08acab/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}